import {Dropdown, DropdownOptionProps, DropdownOptionTextOverflow} from '@wix/wix-ui-tpa/cssVars'
import React from 'react'
import {SELECT_ELEMENTS, SelectProps} from './interfaces'
import {classes, st} from './select.st.css'

export const Select = ({value, options, ariaLabel, onChange, noDefaultValue}: SelectProps) => {
  const selectOptions: DropdownOptionProps[] = options.map((option, index) => ({
    id: String(index),
    value: option,
    isSelectable: true,
    textOverflow: DropdownOptionTextOverflow.wrap,
  }))
  const selectedValue = selectOptions.find(option => option.value === value)

  const getInitialOptionId = () => {
    if (selectedValue) {
      return selectedValue.id
    }

    if (noDefaultValue) {
      return undefined
    }

    if (selectOptions.length) {
      return selectOptions[0].id
    }

    return undefined
  }

  return (
    <Dropdown
      data-hook={SELECT_ELEMENTS.SELECT}
      options={selectOptions}
      onChange={option => onChange(option.value)}
      className={st(classes.root)}
      upgrade
      aria-label={selectedValue?.value ? `${ariaLabel}, ${selectedValue.value}` : ariaLabel}
      initialSelectedId={getInitialOptionId()}
      mobileNativeSelect
      // @ts-expect-error
      errorAppearance="BackgroundAndBorder"
      newErrorMessage
    />
  )
}
